import {
  AcademicStatusType,
  type AcademicSituationDetails,
} from '@/models/learning/academic-situation';
import { formatLongDate } from '@/utils/format-date';

type StatusPaletteKey = 'info' | 'warning' | 'success' | 'error' | 'neutral';

export interface DetailStatusConfig {
  label: string;
  palette: StatusPaletteKey;
  backgroundColor: string;
  color: string;
}

export const detailStatusConfig: Record<AcademicStatusType, DetailStatusConfig> =
  {
    [AcademicStatusType.Pending]: {
      label: 'Inscrição em andamento',
      palette: 'info',
      backgroundColor: 'info.light',
      color: 'info.dark',
    },
    [AcademicStatusType.EnrollmentPending]: {
      label: 'Matrícula pendente',
      palette: 'warning',
      backgroundColor: 'warning.light',
      color: 'warning.dark',
    },
    [AcademicStatusType.InProgress]: {
      label: 'Em andamento',
      palette: 'info',
      backgroundColor: 'info.light',
      color: 'info.dark',
    },
    [AcademicStatusType.Interrupted]: {
      label: 'Interrompido',
      palette: 'error',
      backgroundColor: 'error.light',
      color: 'error.dark',
    },
    [AcademicStatusType.Canceled]: {
      label: 'Cancelado',
      palette: 'neutral',
      backgroundColor: 'neutral.lighter',
      color: 'neutral.dark',
    },
    [AcademicStatusType.Completed]: {
      label: 'Concluído',
      palette: 'success',
      backgroundColor: 'success.light',
      color: 'success.dark',
    },
  };

const lastStatusDate = (
  situation: AcademicSituationDetails,
  statusType: AcademicStatusType
): string | null => {
  const match = situation.statuses.find(
    (status) => status.status_type === statusType
  );

  return match ? formatLongDate(match.occurred_at) : null;
};

export const detailStatusBanner = (
  situation: AcademicSituationDetails
): string | null => {
  switch (situation.current_status) {
    case AcademicStatusType.Pending:
      return 'Aguarde a confirmação da inscrição em até 24 horas';
    case AcademicStatusType.EnrollmentPending:
      return 'Envie um comprovante de matrícula.';
    case AcademicStatusType.InProgress:
      return 'Mantenha o seu curso atualizado';
    case AcademicStatusType.Interrupted: {
      const date = lastStatusDate(situation, AcademicStatusType.Interrupted);
      return date ? `Interrompido em ${date}` : 'Interrompido';
    }
    case AcademicStatusType.Completed: {
      const date = lastStatusDate(situation, AcademicStatusType.Completed);
      return date ? `Concluído em ${date}` : 'Concluído';
    }
    default:
      return null;
  }
};
